// global selectors
import fp from "lodash/fp";

export const isAnyLoading = state => {
  let isLoading = false;

  fp.cloneDeepWith((value, key) => {
    if (key === "isLoading" && value) {
      isLoading = true;
    }
  }, state);

  return isLoading;
};
